const loaderStyle = `
width: 60px;
height: 60px;
background-color: white;
border-radius: 50%;
padding: 16px;
`

const tiendeoLoader = {
  url: '/images/loaders/tiendeo_loader.svg',
  style: loaderStyle,
}

const promoquiLoader = {
  url: '/images/loaders/promoqui_loader.webp',
  style: loaderStyle,
}

const volantinofacileLoader = {
  url: '/images/loaders/volantinofacile_loader.gif',
  style: loaderStyle,
}

const broshuraLoader = {
  url: '/images/loaders/broshura_loader.svg',
  style: loaderStyle,
}

const wogibtswasLoader = {
  url: '/images/loaders/wogibtswas_loader.svg',
  style: loaderStyle,
}

const handelsangeboteLoader = {
  url: '/images/loaders/handelsangebote_loader.svg',
  style: loaderStyle,
}

const prospectoLoader = {
  url: '/images/loaders/prospecto_loader.svg',
  style: loaderStyle,
}

const folderscheckLoader = {
  url: '/images/loaders/folderscheck_loader.svg',
  style: loaderStyle,
}

const getThemeByLayout = layout => {
  switch (layout) {
    case 'tiendeo':
      return {
        viewer: {
          loader: tiendeoLoader,
        },
        navigator: {
          slider: {
            loader: tiendeoLoader,
          },
        },
      }

    case 'promoqui':
      return {
        viewer: {
          loader: promoquiLoader,
        },
        navigator: {
          slider: {
            loader: promoquiLoader,
          },
        },
      }

    case 'volantinofacile':
      return {
        viewer: {
          loader: volantinofacileLoader,
        },
        navigator: {
          slider: {
            loader: volantinofacileLoader,
          },
        },
      }

    case 'broshura':
      return {
        viewer: {
          loader: broshuraLoader,
        },
        navigator: {
          slider: {
            loader: broshuraLoader,
          },
        },
      }

    case 'wogibtswas':
      return {
        viewer: {
          loader: wogibtswasLoader,
          background: '#e6e6e6',
        },
        navigator: {
          slider: {
            loader: wogibtswasLoader,
          },
        },
      }

    case 'handelsangebote':
      return {
        viewer: {
          loader: handelsangeboteLoader,
        },
        navigator: {
          slider: {
            loader: handelsangeboteLoader,
          },
        },
      }

    case 'prospecto':
      return {
        viewer: {
          loader: prospectoLoader,
        },
        navigator: {
          slider: {
            loader: prospectoLoader,
          },
        },
      }

    case 'folderscheck':
      return {
        viewer: {
          loader: folderscheckLoader,
        },
        navigator: {
          slider: {
            loader: folderscheckLoader,
          },
        },
      }

    default:
      return {}
  }
}

export default getThemeByLayout
